export const tickerItems = [
  "【内娱观察室】新增 32 条存档，已按时间线排好序",
  "【网红商业档案】补入 3 份公开工商变更记录",
  "【网络热点复盘】2026-09 月度合集完整度更新至 94%",
  "【品牌危机档案】新增 7 条时间线节点，附来源标注",
  "【直播圈观察】切片与文字稿已对齐归档",
  "【海外社媒趣闻】译文校对完成，标签重新归一",
  "【素人争议合集】旧条目去重 21 条，目录已刷新",
];

export const heroStats = [
  { label: "收录专题", value: "1,286", unit: "个" },
  { label: "归档条目", value: "48,900", unit: "条" },
  { label: "来源档案", value: "512", unit: "份" },
  { label: "今日更新", value: "128", unit: "条" },
];

export const quickEntries = [
  { label: "全部合集", icon: "ri-layout-grid-line", href: "#collections", hint: "1,286" },
  { label: "最新收录", icon: "ri-time-line", href: "#latest", hint: "128" },
  { label: "标签索引", icon: "ri-price-tag-3-line", href: "#tags", hint: "3,940" },
  { label: "来源归档", icon: "ri-links-line", href: "#sources", hint: "512" },
  { label: "热度榜单", icon: "ri-fire-line", href: "#ranking", hint: "TOP 20" },
  { label: "归档下载", icon: "ri-download-2-line", href: "#download", hint: "本周" },
];

export const entryCards = [
  {
    title: "专题合集入口",
    desc: "按主题打包好的合集，一次看完某类内容的全貌，不用来回翻页。",
    icon: "ri-stack-line",
    href: "#collections",
    meta: "1,286 个专题",
    tone: "primary",
  },
  {
    title: "标签索引入口",
    desc: "用标签横向串联同类条目，关键词一搜直达，跳转路径更短。",
    icon: "ri-price-tag-3-line",
    href: "#tags",
    meta: "3,940 个标签",
    tone: "accent",
  },
  {
    title: "来源归档入口",
    desc: "同一来源的公开内容集中列出，方便比对、去重与补充。",
    icon: "ri-links-line",
    href: "#sources",
    meta: "512 份来源",
    tone: "secondary",
  },
  {
    title: "归档下载入口",
    desc: "整包导出专题目录与索引清单，离线也能慢慢整理。",
    icon: "ri-download-2-line",
    href: "#download",
    meta: "每周更新",
    tone: "foreground",
  },
];

export const featuredTopic = {
  badge: "本周主推合集",
  title: "内娱观察室 · 九月完整时间线",
  desc: "把分散在各平台的公开内容按时间顺序归位，从事件起点到后续回应逐条排列，附来源与标签，适合想一次性理清来龙去脉的读者。",
  cover:
    "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20layered%20newspaper%20clippings%20film%20reels%20and%20ink%20smudges%20on%20warm%20aged%20paper%20background%2C%20muted%20vermillion%20and%20deep%20rust%20accent%20tones%2C%20film%20grain%20texture%2C%20stylized%20magazine%20cover%20art%2C%20soft%20directional%20lighting%2C%20no%20text%2C%20no%20faces%2C%20consistent%20warm%20editorial%20palette&width=1600&height=900&seq=hlc-feature-01&orientation=landscape",
  count: "1,204 条",
  tags: ["时间线", "公开来源", "去重整理"],
  updated: "今日 09:20 更新",
};

export const topicCollections = [
  {
    title: "网红商业档案",
    desc: "把公开的商业变动、合作与注销记录归到一处，方便横向比对。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20cover%20of%20geometric%20folder%20tabs%20receipts%20and%20torn%20ledger%20pages%20on%20warm%20cream%20paper%20background%2C%20amber%20and%20rust%20accent%20tones%2C%20editorial%20collage%20design%2C%20subtle%20film%20grain%2C%20no%20text%2C%20no%20faces%2C%20consistent%20warm%20palette&width=900&height=700&seq=hlc-topic-01&orientation=landscape",
    count: 386,
    tags: ["工商变更", "合作记录"],
    updated: "2 小时前",
  },
  {
    title: "网络热点复盘",
    desc: "热点从起势到收尾的完整轨迹，按节点归纳，顺序一目了然。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20cover%20illustration%20of%20layered%20speech%20bubbles%20turning%20into%20paper%20planes%20on%20warm%20beige%20background%2C%20vermillion%20and%20ochre%20accents%2C%20minimal%20editorial%20poster%20art%2C%20film%20grain%20texture%2C%20no%20text%2C%20no%20faces%2C%20consistent%20warm%20palette&width=900&height=700&seq=hlc-topic-02&orientation=landscape",
    count: 512,
    tags: ["时间线", "节点复盘"],
    updated: "5 小时前",
  },
  {
    title: "品牌危机档案",
    desc: "品牌公开声明与后续动作放在一起，出场顺序清楚可见。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cover%20of%20cracked%20ceramic%20plate%20and%20folded%20document%20silhouettes%20on%20muted%20paper%20background%2C%20rust%20red%20and%20sand%20tones%2C%20abstract%20editorial%20still%20life%2C%20film%20grain%2C%20no%20text%2C%20no%20faces%2C%20consistent%20warm%20palette&width=900&height=700&seq=hlc-topic-03&orientation=landscape",
    count: 274,
    tags: ["公开声明", "后续动作"],
    updated: "昨日 21:40",
  },
  {
    title: "直播圈观察",
    desc: "切片、文字稿与场次记录对齐归档，回看时不用再东找西找。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20cover%20art%20of%20vintage%20studio%20spotlight%20beams%20and%20cable%20wires%20on%20warm%20paper%20texture%2C%20amber%20and%20deep%20red%20accents%2C%20minimal%20editorial%20poster%20aesthetic%2C%20film%20grain%2C%20no%20text%2C%20no%20faces%2C%20consistent%20warm%20palette&width=900&height=700&seq=hlc-topic-04&orientation=landscape",
    count: 458,
    tags: ["切片", "文字稿"],
    updated: "昨日 18:05",
  },
  {
    title: "海外社媒趣闻",
    desc: "跨平台内容译好、校对好再入档，标签统一，检索更好用。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20abstract%20cover%20of%20globe%20wireframe%20and%20envelope%20shapes%20on%20cream%20paper%20background%2C%20warm%20ochre%20and%20rust%20accents%2C%20editorial%20collage%20design%2C%20film%20grain%2C%20no%20text%2C%20no%20faces%2C%20consistent%20warm%20palette&width=900&height=700&seq=hlc-topic-05&orientation=landscape",
    count: 197,
    tags: ["译文", "标签归一"],
    updated: "2 天前",
  },
  {
    title: "素人争议合集",
    desc: "把零散讨论按主题合并，重复内容清理掉，目录更清爽。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20cover%20of%20overlapping%20paper%20scraps%20pinned%20on%20a%20cork%20board%20on%20warm%20cream%20background%2C%20muted%20terracotta%20and%20olive%20accents%2C%20minimal%20editorial%20collage%20aesthetic%2C%20film%20grain%2C%20no%20text%2C%20no%20faces%2C%20consistent%20warm%20palette&width=900&height=700&seq=hlc-topic-06&orientation=landscape",
    count: 341,
    tags: ["主题合并", "去重"],
    updated: "3 天前",
  },
];

export const latestFeeds = {
  fresh: [
    { id: "f1", title: "某平台主播合作纠纷 · 时间线已补齐到 9 月 8 日", source: "公开报道 + 平台公告", tags: ["时间线", "合作纠纷"], time: "12 分钟前", icon: "ri-time-line", tone: "primary" },
    { id: "f2", title: "品牌 A 二次回应整理：两份声明的差异点已标注", source: "官方账号", tags: ["公开声明", "对照"], time: "48 分钟前", icon: "ri-file-text-line", tone: "secondary" },
    { id: "f3", title: "海外社媒热门话题译文校对完成，标签重新归一", source: "跨平台汇总", tags: ["译文", "标签归一"], time: "2 小时前", icon: "ri-translate-2", tone: "accent" },
    { id: "f4", title: "旧条目去重 21 条，素人争议合集目录已刷新", source: "站内整理", tags: ["去重", "目录刷新"], time: "4 小时前", icon: "ri-filter-3-line", tone: "foreground" },
    { id: "f5", title: "直播场次记录补入 9 条，切片与文字稿已对齐", source: "场次回放", tags: ["切片", "文字稿"], time: "6 小时前", icon: "ri-live-line", tone: "primary" },
    { id: "f6", title: "网红商业档案新增 3 份公开工商变更记录", source: "公开信息", tags: ["工商变更", "存档"], time: "9 小时前", icon: "ri-briefcase-4-line", tone: "secondary" },
  ],
  hot: [
    { id: "h1", title: "内娱观察室 · 九月完整时间线（本周收藏最多）", source: "多来源汇总", tags: ["时间线", "精选"], time: "今日 09:20", icon: "ri-fire-line", tone: "primary" },
    { id: "h2", title: "网络热点复盘：三个节点的先后顺序对照表", source: "公开来源", tags: ["节点复盘", "对照表"], time: "今日 08:05", icon: "ri-node-tree", tone: "accent" },
    { id: "h3", title: "品牌危机档案：四份声明的措辞变化梳理", source: "官方账号", tags: ["公开声明", "措辞"], time: "昨日 22:10", icon: "ri-file-text-line", tone: "secondary" },
    { id: "h4", title: "直播圈观察：同场内容多版本差异点标记", source: "场次回放", tags: ["切片", "差异点"], time: "昨日 19:40", icon: "ri-live-line", tone: "foreground" },
    { id: "h5", title: "素人争议合集：被重复搬运的 12 条内容合并记录", source: "站内整理", tags: ["去重", "合并记录"], time: "昨日 16:15", icon: "ri-filter-3-line", tone: "primary" },
    { id: "h6", title: "海外社媒趣闻：本周译文高频标签 TOP 10", source: "跨平台汇总", tags: ["译文", "高频标签"], time: "昨日 11:00", icon: "ri-translate-2", tone: "accent" },
  ],
};

export const tagIndex = [
  { name: "时间线", count: 412, level: 3 },
  { name: "公开声明", count: 386, level: 3 },
  { name: "去重整理", count: 254, level: 2 },
  { name: "切片", count: 341, level: 3 },
  { name: "文字稿", count: 228, level: 2 },
  { name: "译文", count: 176, level: 2 },
  { name: "标签归一", count: 143, level: 1 },
  { name: "工商变更", count: 121, level: 1 },
  { name: "合作记录", count: 208, level: 2 },
  { name: "节点复盘", count: 197, level: 2 },
  { name: "目录刷新", count: 96, level: 1 },
  { name: "对照表", count: 134, level: 1 },
  { name: "存档", count: 302, level: 3 },
  { name: "来源标注", count: 188, level: 2 },
  { name: "跨平台", count: 165, level: 2 },
  { name: "高频标签", count: 88, level: 1 },
  { name: "措辞变化", count: 74, level: 1 },
  { name: "场次记录", count: 152, level: 1 },
  { name: "精选合集", count: 236, level: 2 },
  { name: "旧闻回溯", count: 112, level: 1 },
  { name: "一次性收齐", count: 268, level: 3 },
  { name: "按来源找", count: 149, level: 1 },
];

export const sourceArchive = [
  { name: "公开报道归档", category: "媒体来源", count: 168, icon: "ri-newspaper-line" },
  { name: "官方账号原文", category: "一手声明", count: 132, icon: "ri-verified-badge-line" },
  { name: "平台页面对照", category: "页面留档", count: 96, icon: "ri-window-2-line" },
  { name: "公开工商信息", category: "登记信息", count: 54, icon: "ri-briefcase-4-line" },
  { name: "场次回放记录", category: "直播来源", count: 41, icon: "ri-live-line" },
  { name: "跨平台译文", category: "译文来源", count: 12, icon: "ri-translate-2" },
  { name: "站内整理稿", category: "二次归纳", count: 8, icon: "ri-file-edit-line" },
  { name: "读者补录线索", category: "线索来源", count: 1, icon: "ri-lightbulb-flash-line" },
];

export const rankingBoards = {
  topics: [
    { name: "内娱观察室 · 九月完整时间线", value: "1,204 条", trend: "up" },
    { name: "网络热点复盘 · 节点对照表", value: "932 条", trend: "up" },
    { name: "品牌危机档案 · 声明措辞变化", value: "786 条", trend: "flat" },
    { name: "直播圈观察 · 多版本差异标记", value: "654 条", trend: "up" },
    { name: "网红商业档案 · 合作记录汇总", value: "512 条", trend: "down" },
    { name: "素人争议合集 · 去重合并记录", value: "438 条", trend: "flat" },
    { name: "海外社媒趣闻 · 高频标签榜", value: "361 条", trend: "up" },
    { name: "旧闻回溯 · 一次性收齐", value: "298 条", trend: "down" },
  ],
  tags: [
    { name: "时间线", value: "412 次命中", trend: "up" },
    { name: "公开声明", value: "386 次命中", trend: "flat" },
    { name: "切片", value: "341 次命中", trend: "up" },
    { name: "存档", value: "302 次命中", trend: "up" },
    { name: "一次性收齐", value: "268 次命中", trend: "flat" },
    { name: "去重整理", value: "254 次命中", trend: "up" },
    { name: "精选合集", value: "236 次命中", trend: "down" },
    { name: "文字稿", value: "228 次命中", trend: "flat" },
  ],
};

export const downloadPacks = [
  { name: "本周专题目录", size: "2.4 MB", format: "PDF 目录", icon: "ri-file-pdf-2-line" },
  { name: "索引清单（含标签）", size: "860 KB", format: "CSV 表格", icon: "ri-file-excel-2-line" },
  { name: "来源对照表", size: "1.1 MB", format: "XLSX 表格", icon: "ri-table-line" },
];

export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "专题合集", href: "#collections" },
  { label: "最新收录", href: "#latest" },
  { label: "标签索引", href: "#tags" },
  { label: "来源归档", href: "#sources" },
  { label: "热度榜单", href: "#ranking" },
];